import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import DifferentActivity from './DifferentActivity'

import { setActivitiesLoadStatusToDefault } from 'store/entities/differentActivities/actions'
import { getIdentityActions, isUserCanSwitchProtrack } from 'store/entities/identity/selectors'

const mapDispatchToProps = {
  setActivitiesLoadStatusToDefault,
}

const mapStateToProps = state => ({
  actions: getIdentityActions(state),
  isUserCanSwitchProtrack: isUserCanSwitchProtrack(state),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DifferentActivity))
